import { Component, OnInit } from '@angular/core';
import { WizardStepComponent } from './wizard-step/wizard-step.component';
import { TitleBarComponent } from 'src/app/base/shared/title-bar/title-bar.component';

@Component({
    selector: 'app-onboarding-wizard',
    templateUrl: './onboarding-wizard.component.html',
    styleUrls: ['./onboarding-wizard.component.scss'],
    imports: [
        WizardStepComponent, TitleBarComponent
    ]
})
export class OnboardingWizardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
